import { render, staticRenderFns } from "./DeleteBranchLink.vue?vue&type=template&id=3ad185aa"
import script from "./DeleteBranchLink.vue?vue&type=script&lang=js"
export * from "./DeleteBranchLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports